<template>
    <div>
        <div v-if="disableSaveButton" class="controls">
            <ds-dropdown class="dropdown" position="bottom-end">
                <ds-icon-button id="contactInfoHeaderControlsIcon" class="icon-only">
                    <ds-icon data-qa="drop-down" name="more-horizontal" />
                </ds-icon-button>

                <div slot="menu">
                    <ul class="dropdown-menu-list">
                        <li
                            class="dropdown-menu-item"
                            data-qa="delete-contact"
                            @click="showConfirmModal"
                        >
                            <ds-icon class="menu-item-icon" name="trash-2" />
                            Delete contact
                        </li>
                        <li
                            class="dropdown-menu-item"
                            data-qa="custom-layout"
                            @click="contactLayout"
                        >
                            <ds-icon class="menu-item-icon" name="settings" />
                            Customize contact record
                        </li>
                    </ul>
                </div>
            </ds-dropdown>

            <ds-filled-button
                data-qa="update-contact"
                type="submit"
                @click="saveCustomFields"
            >
                Save
            </ds-filled-button>

            <delete-contact
                ref="confirmModal"
                :contact-id="Number(id)"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import DeleteContact from './DeleteContact';

export default {
    components: {
        DeleteContact,
    },

    props: {
        id: [String, Number],
        contactDetails: Object,
    },

    data() {
        return {
            disableSaveButton: true,
            contactPermissionDTO: {},
            isContactLayoutEnabled: false,
        };
    },

    beforeDestroy() {
        this.$root.$off('DISABLE_SAVE_BUTTON');
    },

    created() {
        this.load();
    },

    mounted() {
        this.$root.$on('DISABLE_SAVE_BUTTON', (data) => {
            this.disableSaveButton = data;
        });
    },

    methods: {
        async saveCustomFields() {
            try {
                const message = 'Saved custom fields';

                await axios.put('/app/contact/layout', this.contactDetails);
                this.$toast({ message });
            } catch (error) {
                this.$error({ message: 'error while updating fields' });
            }
        },

        showConfirmModal() {
            this.$refs.confirmModal.showModal();
        },

        contactLayout() {
            if (this.isContactLayoutEnabled) {
                this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', true);
                this.$root.$emit('CUSTOMIZED_CONTACT_RECORD', true);
            }
        },

        async load() {
            this.getFeatureFlagValue();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/contact/isContactLayoutEnabled');

                this.isContactLayoutEnabled = response.data;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .controls {
        display: flex;
        justify-content: flex-end;
        margin-top: $spacing-200;

        > *:first-child {
            @include margin-end(12px);
        }
    }
</style>
